import { render, staticRenderFns } from "./NextRef.vue?vue&type=template&id=3c8fd472&scoped=true"
import script from "./NextRef.vue?vue&type=script&lang=js"
export * from "./NextRef.vue?vue&type=script&lang=js"
import style0 from "./NextRef.vue?vue&type=style&index=0&id=3c8fd472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8fd472",
  null
  
)

export default component.exports